module.exports = __webpack_public_path__ + "static/media/ic_template_4.bcdc06bb.png";